import styles from "./OptionCard.module.css";
import type { PropsWithChildren, ReactNode } from "react";

interface OptionCardProps {
  icon: ReactNode;
  label: string;
  isSelected?: boolean;
  onClick: () => void;
  /** Icon background shape. Defaults to a circle; the email list uses a square. */
  iconShape?: "circle" | "square";
  /** Render the label bold rather than the default semibold. */
  boldLabel?: boolean;
}

function OptionCard({
  icon,
  label,
  isSelected = false,
  onClick,
  iconShape = "circle",
  boldLabel = false,
}: OptionCardProps) {
  return (
    <button
      type="button"
      className={`${styles.card}${isSelected ? ` ${styles.cardSelected}` : ""}`}
      onClick={onClick}
      aria-pressed={isSelected}
    >
      <div
        className={`${styles.cardIcon}${iconShape === "square" ? ` ${styles.cardIconSquare}` : ""}${
          isSelected ? ` ${styles.cardIconSelected}` : ""
        }`}
      >
        {icon}
      </div>
      <div className={`fontSize--m ${boldLabel ? "fontWeight--bold" : "fontWeight--semibold"}`}>
        {label}
      </div>
    </button>
  );
}

interface OptionCardGroupProps {
  /** Keep one card per row at every width, rather than side by side on wide viewports. */
  stacked?: boolean;
}

function OptionCardGroup({ children, stacked = false }: PropsWithChildren<OptionCardGroupProps>) {
  return (
    <div className={`${styles.optionCards}${stacked ? ` ${styles.stacked}` : ""}`}>{children}</div>
  );
}

export { OptionCard, OptionCardGroup };
